import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import keycode from 'keycode';
import AutosizeInput from 'react-input-autosize';
import { addTag, removeTag, updateTag } from '../../actions/post';
import { MAX_TAG_COUNT } from '../../constants/limits';

function Tag (props) {
  const { index, tag, onRemove, onUpdate, deleteBtnRef, tagInputRef } = props;
  const [updateMode, setUpdateMode] = useState(false);

  useEffect(() => {
    !updateMode && tagInputRef.current && tagInputRef.current.focus();
  }, [updateMode, tagInputRef]);

  function handleUpdate (value) {
    onUpdate(tag, value);
    setUpdateMode(false);
  }

  if (updateMode) {
    return (
      <TagInput defaultValue={tag} onSave={handleUpdate} />
    );
  } else {
    return (
      <span key={tag} className="txt_tag">
        <a href="#" role="button" aria-label={`${tag} 태그 수정`} onClick={() => setUpdateMode(true)}>#{tag}</a>
        <a href="#" role="button" ref={deleteBtnRef} className="btn_delete" onClick={() => onRemove(tag, index)}>
          <span className="mce-ico ico_delete">{`${tag} 태그 삭제`}</span>
        </a>
      </span>
    );
  }
}


function TagInput ({ defaultValue, onSave, tagInputRef }) {
  const [value, setValue] = useState(defaultValue);
  let inputRef = null;
  useEffect(() => {
    if (inputRef) {
      inputRef.focus();
    }
  }, []);

  function handleKeyDown (e) {
    const code = keycode(e);

    if (code === ',' || code === 'enter' || (code === 'tab' && value !== '')) {
      e.preventDefault();
      onSave(value);
      setValue('');
    }
  }

  function handleBlur (e) {
    onSave(value);
    setValue('');
  }

  function handleChange (e) {
    const values = e.target.value.split(',');
    do {
      const val = values.shift();
      if (values.length === 0) {
        setValue(val);
      } else {
        onSave(val);
      }
    } while (values.length !== 0);
  }

  return (
    <span className="inp_tag">
      <span>#</span>
      <AutosizeInput
        ref={tagInputRef}
        inputRef={input => { inputRef = input; }}
        type="text"
        title="태그"
        name="tagText"
        id="tagText"
        value={value}
        inputClassName="tf_g"
        placeholder="태그입력"
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        onChange={handleChange}
      />
    </span>
  );
}

export default function PostTags () {
  if (Config.postType !== 'post') {
    return null;
  }

  const tags = useSelector(state => state.post.newPost.tags);
  const dispatch = useDispatch();

  const tagsRef = useRef([]);
  const tagInputRef = useRef(null);

  useEffect(() => {
    tagsRef.current = tagsRef.current.slice(0, tags.length);
  }, [tags]);

  function handleAddTag (tag) {
    dispatch(addTag(tag));
  }
  function handleRemoveTag (tag, index) {
    dispatch(removeTag(tag));

    if (tagsRef.current.length < MAX_TAG_COUNT) {
      tagsRef.current.length === (index + 1)
        ? tagInputRef.current.focus()
        : tagsRef.current[index + 1].focus();
    }
  }
  function handleUpdateTag (orgTag, tag) {
    dispatch(updateTag(orgTag, tag));
  }

  function handleAdd (tag) {
    const value = tag.replace(/,/g, '').trim();
    if (value !== '') {
      handleAddTag(value);
    }
  }

  function handleUpdate (orgTag, tag) {
    const value = tag.replace(/,/g, '').trim();
    if (value !== '') {
      handleUpdateTag(orgTag, value);
    }
  }

  return (
    <div className="editor_tag">
      {tags && tags.map((tag, i) => (
        <Tag
          key={tag}
          tag={tag}
          index={i}
          onRemove={handleRemoveTag}
          onUpdate={handleUpdate}
          tagInputRef={tagInputRef}
          deleteBtnRef={el => {
            tagsRef.current[i] = el;
            return el;
          }}
        />
      ))}

      {(!tags || tags.length < MAX_TAG_COUNT) &&
        <TagInput tagInputRef={tagInputRef} defaultValue='' onSave={handleAdd} />
      }
    </div>
  );
}
